import React from 'react';
import ListTradeCard from './ListTradeCard';
import GridTradeCard from './GridTradeCard';
import { ListVariant } from '../../_shared/types/trade';

const TradeCard = props => {
  const { variant } = props;
  return variant !== ListVariant.GRID ? (
    // the "list" trade card is used in all variants but "grid"
    <ListTradeCard {...props} />
  ) : (
    <GridTradeCard {...props} />
  );
};

export default TradeCard;
